import { render, staticRenderFns } from "./ClientsCrud.vue?vue&type=template&id=3da99780&scoped=true&"
import script from "./ClientsCrud.vue?vue&type=script&lang=js&"
export * from "./ClientsCrud.vue?vue&type=script&lang=js&"
import style0 from "./ClientsCrud.vue?vue&type=style&index=0&id=3da99780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da99780",
  null
  
)

export default component.exports